import { Link } from 'react-router-dom';
import { ROUTES } from '../../constants/routes';

function StatusIcon({ status }) {
  if (status === 'pending') {
    return (
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#E8F4FC]">
        <div className="h-7 w-7 animate-spin rounded-full border-4 border-[#1A87CC] border-t-transparent" />
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#E8F5D8]">
        <svg className="h-8 w-8 text-[#69991D]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
        </svg>
      </div>
    );
  }

  return (
    <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-50">
      <svg className="h-8 w-8 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
  );
}

export default function PaymentStatusModal({
  open,
  status,
  planName,
  amount,
  message,
  paymentUrl,
  onClose,
  onOpenPayment,
  onCheckPaid,
  checking,
}) {
  if (!open || !status) return null;

  const title =
    status === 'pending'
      ? 'Complete Your Payment'
      : status === 'success'
        ? 'Payment Successful'
        : 'Payment Failed';

  const body =
    message ||
    (status === 'pending'
      ? 'Complete payment in the Razorpay window. This page will update automatically.'
      : status === 'success'
        ? 'Your subscription is active. You can start learning right away.'
        : 'Your payment could not be completed. Please try again.');

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/45 p-4">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="payment-status-title"
        className="w-full max-w-md rounded-2xl bg-white px-6 py-8 text-center shadow-[0_8px_40px_rgba(0,0,0,0.18)] sm:px-8"
      >
        <StatusIcon status={status} />
        <h2 id="payment-status-title" className="mt-5 text-xl font-bold text-[#1B1B1B] sm:text-2xl">
          {title}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-[#666666]">{body}</p>

        {(planName || amount != null) && (
          <div className="mt-5 rounded-xl bg-[#F5F8FC] px-4 py-3 text-left text-sm text-[#1B1B1B]">
            {planName ? (
              <p>
                <span className="text-[#999999]">Plan: </span>
                {planName}
              </p>
            ) : null}
            {amount != null ? (
              <p className="mt-1">
                <span className="text-[#999999]">Amount: </span>₹{amount}
              </p>
            ) : null}
          </div>
        )}

        <div className="mt-7 flex flex-col gap-3">
          {status === 'pending' ? (
            <>
              <button
                type="button"
                onClick={onOpenPayment}
                className="rounded-lg bg-[#1A87CC] px-5 py-3 text-sm font-semibold text-white transition hover:opacity-90"
              >
                Open Payment Page
              </button>
              <button
                type="button"
                onClick={onCheckPaid}
                disabled={checking}
                className="rounded-lg border border-[#1A87CC] px-5 py-3 text-sm font-semibold text-[#1A87CC] transition hover:bg-[#1A87CC]/5 disabled:opacity-60"
              >
                {checking ? 'Checking…' : 'I’ve paid'}
              </button>
              {paymentUrl ? (
                <a
                  href={paymentUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-sm text-[#1A87CC] underline"
                >
                  Open payment link in new tab
                </a>
              ) : null}
              <button
                type="button"
                onClick={onClose}
                className="text-sm font-medium text-[#999999] transition hover:text-[#1B1B1B]"
              >
                Cancel
              </button>
            </>
          ) : null}

          {status === 'success' ? (
            <>
              <button
                type="button"
                onClick={onClose}
                className="rounded-lg bg-[#1A87CC] px-5 py-3 text-sm font-semibold text-white transition hover:opacity-90"
              >
                Continue
              </button>
              <Link
                to={ROUTES.HOME}
                onClick={onClose}
                className="text-sm font-medium text-[#1A87CC] hover:underline"
              >
                Go to Home
              </Link>
            </>
          ) : null}

          {status === 'failed' ? (
            <button
              type="button"
              onClick={onClose}
              className="rounded-lg bg-[#1A87CC] px-5 py-3 text-sm font-semibold text-white transition hover:opacity-90"
            >
              Try Again
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}
